import React, { useState } from "react";

const ErrorHandler = (error: any) => {
  // console.log(error);
};

export default ErrorHandler;
